import {
    buttonClassName,
    pxToRem,
    labelClassName,
    dropdownClassName,
    dropdownSortSlotClassNames,
    pxArrayToRem,
    captionClassName,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { LEFT_SIDE_WIDTH } from '~/modules/design-board/config';

export const BaseStyle: StyleRule = ({ theme }) => ({
    [theme.screen.min.tablet]: {
        alignItems: 'center',
        padding: pxArrayToRem([0, 50, 0, 0]),
        minHeight: pxToRem(80),
        borderBottom: '1px solid #EAEAEA', // color can not find in aria
    },
    minHeight: pxToRem(325),
    justifyContent: 'space-between',
    width: '100%',

    [theme.screen.clamped]: {
        paddingRight: 0,
    },
});

export const BackBtnWrap: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        width: pxToRem(LEFT_SIDE_WIDTH),
        padding: pxArrayToRem([0, 28]),
        marginRight: pxToRem(50),

        [`& .${captionClassName}`]: {
            margin: pxArrayToRem([4, 0, 0, -8]),
        },
    },

    [theme.screen.clamped]: {
        paddingLeft: 0,
    },
});

export const Header: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        fontSize: pxToRem(18),
        letterSpacing: theme.siteVariables.letterSpacingSmall,
        marginLeft: pxToRem(-2),
    },
});

export const PinAndFollower: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        flexGrow: 1,
        margin: pxArrayToRem([0, 31]),

        [`& .${svgIconClassName}`]: {
            width: pxToRem(18),
            height: pxToRem(18),
            margin: pxArrayToRem([3, 17, 0, -11]),
        },

        [`& .${captionClassName}`]: {
            color: theme.siteVariables.colors.grey[300],
            fontSize: pxToRem(16),
            letterSpacing: theme.siteVariables.letterSpacingSmall,
            padding: pxArrayToRem([2, 0, 0, 3]),
        },
    },
});

export const FilterBarButtons: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        columnGap: pxToRem(12),
        marginRight: pxToRem(-3),
        [`& > .${buttonClassName}`]: {
            height: pxToRem(44),
            [`& > .${labelClassName}`]: {
                fontSize: pxToRem(14),
            },
        },

        [`& .${dropdownClassName}`]: {
            [`& .${dropdownSortSlotClassNames.currentItem}`]: {
                order: 1,
                fontSize: pxToRem(14),
                textTransform: 'uppercase',
            },
            [`& .${svgIconClassName}`]: {
                order: 2,
                width: pxToRem(12),
                height: pxToRem(12),
                margin: pxArrayToRem([0, 0, 0, 8]),
            },
        },
    },
});

export const UploadButton: StyleRule = () => ({
    width: pxToRem(128),
    [`& .${labelClassName}`]: {
        paddingRight: pxToRem(4),
    },
    [`& span > .${svgIconClassName}`]: {
        width: pxToRem(12),
        height: pxToRem(12),
    },
});

export const CommentButton: StyleRule = () => ({
    width: pxToRem(151),
    [`& .${labelClassName}`]: {
        paddingRight: pxToRem(3),
    },
    [`& .${svgIconClassName}`]: {
        paddingRight: pxToRem(18),
    },
});

export const EditButton: StyleRule = () => ({
    width: pxToRem(99),
    [`& .${labelClassName}`]: {
        paddingRight: pxToRem(9),
    },
    [`& .${svgIconClassName}`]: {
        marginRight: pxToRem(-4),
        marginTop: pxToRem(-3),
        width: pxToRem(15),
        height: pxToRem(15),
    },
});

export const ShareButton: StyleRule = () => ({
    width: pxToRem(117),
    [`& .${labelClassName}`]: {
        paddingRight: pxToRem(9),
    },
    [`& .${svgIconClassName}`]: {
        marginRight: pxToRem(-2),
    },
});
